export const receiptStyle = `
        <style>
        body {
            font-family: 'Arial', sans-serif;
            margin: 20px;
            color: #333;
        }
        h1, h2, h4 {
            text-align: center;
            margin-bottom: 20px;
            color: #222;
        }
        .item {
            border-bottom: 1px dashed #ccc;
            padding: 8px 0;
        }
        .item-name {
            font-weight: 600;
            font-size: 15px;
        }
        .item-price {
            float: right;
            color: #555;
        }
        .details {
            font-size: 14px;
            margin-top: 4px;
            color: #555;
        }
        .summary {
            margin-top: 20px;
            border-top: 2px solid #000;
            padding-top: 10px;
            font-size: 15px;
        }
        .summary p {
            display: flex;
            justify-content: space-between;
            margin: 6px 0;
        }
        .summary p span:first-child {
            font-weight: 600;
        }
        .footer {
            text-align: center;
            font-size: 12px;
            color: #999999;
            margin-top: 30px;
        }
        </style>
    `